import { getLanguageTag } from '@vista/omnichannel-components-domain';
export const mapFormDataToOrderCustomer = (formData) => {
    const { givenName, familyName, email, phoneNumber } = formData;
    return {
        name: { givenName, familyName },
        email,
        phoneNumber,
        preferences: { languageTag: getLanguageTag() }
    };
};
